import React, { useEffect, useState, useCallback } from "react";
import { Box, Grid, Grid2, Button, Dialog, Typography } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  deleteProject,
  getProject,
  updateProject,
} from "../../services/project.service";
import AddProject from "../../components/Project/AddProject";
import { getTokenbyData } from "../../services/user.service";
import { getClientProject } from "../../services/client.service";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { encryptData } from "../../utils/cryptoUtils";
import { jwtDecode } from "jwt-decode";

import { debounce } from "../../utils/debounce";
import { useAuth } from "../../context/AuthProvider";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";

const Project = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { accessToken } = useAuth();
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [data, setData] = useState([]);
  const [openLoader, setOpenLoader] = useState(true);
  const [tableTotalCount, setTableTotalCount] = useState(0);
  console.log(tableTotalCount, "TTC");

  const encrypt = (text) => btoa(text);
  const decrypt = (text) => atob(text);

  const encryptQueryParam = (param) => {
    return btoa(JSON.stringify(param));
  };

  //decode Token
  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };
  const userId = getUserIdFromToken();
  // const userId = localStorage.getItem("_id");
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
  });

  const fetchData = async () => {
    try {
      const res = await getTokenbyData();
      const usersData = res.data;
      const isClient = usersData?.isClient || false;
      const encryptedQueryParam = {
        search: encryptData(queryParam.search),
        page: encryptData(queryParam.page),
        limit: encryptData(queryParam.limit),
        sortType: encryptData(queryParam.sortType),
        sort: encryptData(queryParam.sort),
        isEnabled: encryptData(queryParam.isEnabled),
        // clientId: encryptData(queryParam.clientId),
        // employeeId : encryptData(queryParam.employeeId)
      };
      if (isClient) {
        const clientProjects = await getClientProject(userId, queryParam);
        setData(clientProjects?.data.data.projectDetails || []);
      } else {
        const projects = await getProject(queryParam);
        console.log(projects, "pppppp");
        setData(projects.data.data || []);
        setTableTotalCount(projects?.data?.totalCount);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    } finally {
      setOpenLoader(false); // Ensure loader is turned off after fetching
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    userId,
    queryParam.search,
    queryParam.page,
    queryParam.limit,
    queryParam.sort,
  ]);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleToggle = async (e) => {
    try {
      const updatedRow = { ...e, isEnabled: !e.isEnabled };
      const res = await updateProject(e._id, {
        isEnabled: updatedRow.isEnabled,
      });
      setData((prevData) =>
        prevData.map((item) => (item._id === e._id ? updatedRow : item))
      );
      if (updatedRow.isEnabled) {
        ToastSuccess(res?.data?.message);
      } else {
        if (res) {
          ToastError(res?.data?.message);
        } else {
          ToastError("Project Deactivated");
        }
      }
      await fetchData();
    } catch (error) {
      console.error("Error updating project:", error);
    }
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteProject(e._id);
      ToastError(res.message);
      await fetchData();
    } catch (error) {
      console.log(error);
    }
  };

  if (openLoader) {
    // return <CommonLoader />; // Show loading text or spinner
    return (
      <Typography>
        <CommonLoader />
      </Typography>
    );
  }

  const columns = [
    { id: "name", label: "Name" },
    { id: "shortName", label: "Short Name" },
    { id: "title", label: "Title" },
    { id: "description", label: "Description" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: true,
    isEdit: canEdit("project"),
    isToggle: true,
    isView: true,
    isDelete: canDelete("project"),
    isAdmin: true,
  };
  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={2.5}>
            <Box className="SearchInputBoxContainer">
              <SearchOutlinedIcon className="Search_Icon" />
              <input
                className="SearchInputBox"
                placeholder="Search here"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Box>
          </Grid>
          {/* <Grid item xs={12} sm={3} /> */}
          <Grid item xs={12} sm={6.5} />
          <Grid item xs={12} sm={1.7}>
            <PermissionGate module="project" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAdd()}
                className="Add-Button"
              >
                Add Project
              </Button>
            </PermissionGate>
          </Grid>
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleEdit={handleEdit}
        handleView={handleView}
        handleToggle={handleToggle}
        handleDelete={handleDelete}
        isServerSide={true}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />

      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <AddProject
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={fetchData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default Project;
